import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import LinearIndeterminate from 'components/LinearLoader'

const TableLoader = () => {
  return (
    <TableRow sx={{ width: '100%', display: 'block' }}>
      <TableCell sx={{ width: '100%', display: 'block', padding: 0, border: 0 }}>
        <LinearIndeterminate />
      </TableCell>
    </TableRow>
  )
}

export default TableLoader
